// Module
var code = "<div class=\"modal-header\"> <h4 class=\"modal-title\"> <i class=\"fas fa-exclamation-triangle\"></i> &nbsp; <span translate=\"TIMED_OUT_MODAL.TITLE\"></span> </h4> </div> <div class=\"modal-body\" style=\"border-bottom-right-radius:7px;border-bottom-left-radius:7px\"> <p translate=\"TIMED_OUT_MODAL.MESSAGE\"></p> </div>";
// Exports
export default code;